/**
 * UX helpers for read-only vs mutation RBAC.
 * Prefer disabling controls (with a title hint) over hiding them.
 */

export const NO_PERMISSION_HINT =
  "You don't have permission for this action.";

/**
 * @param {boolean} allowed
 * @param {string} [actionLabel] - e.g. "trigger workflows"
 * @returns {string | undefined}
 */
export function permissionDeniedTitle(allowed, actionLabel) {
  if (allowed) return undefined;
  if (actionLabel) return `You don't have permission to ${actionLabel}.`;
  return NO_PERMISSION_HINT;
}
